document.addEventListener('DOMContentLoaded', function() {
    const element = document.querySelector('.needsclick.kl-private-reset-css-Xuajs1');
    
    if (element) {
        element.addEventListener('click', function() {
            this.style.display = 'none';  // Hide the element on click
        });
    }
});